﻿import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Root = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1) // ml=1 == marginLeft: theme.spacing(1)
}));

type ActionsMenuItemLabelProps = React.ComponentPropsWithoutRef<'span'>

/**
 * MUI Typography component styled in the SecurSpace way. Used for the label portion of each MenuItem for stylized text labels
 * @param children children passed through to the internal Typography component
 * @param rest The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const ActionsMenuItemLabel = ({ children, ...rest }: ActionsMenuItemLabelProps) => {
  return <Root variant={'body1'} color={'primary'} {...rest}>
    { children }
  </Root>
}

export { ActionsMenuItemLabel };